import { createCRUDHook } from './createCRUDHook';
import {
  RolesDto,
  RolesListItem,
  RolesUpdateDto,
} from 'utils/models';
import {
  GET_ROLE_PERMISSIONS_BY_ROLE_ID,
  GET_ROLE_PERMISSIONS_BY_USER_ID,
  ROLE,
  TLKP_ROLES,
  TLKP_ROLES_PERMISSONS,
  TLKP_ROLES_PERMISSONS_UPDATE,
  TLKP_ROLES_WITH_PERMISSIONS,
} from './apiEndPoints';
import { AxiosResponse } from 'axios';

interface RoleCustomOperations {
  getRolesPermissionData: () => Promise<RolesListItem[]>;
  addRolePermission: (param: any) => Promise<AxiosResponse>;
  updateRolePermissions: (params: RolesUpdateDto) => Promise<AxiosResponse>;
  getRolepermissionsByRoleId: (roleId: number) => Promise<RolesListItem[]>;
  getRolePermissionsByUserId: (userId: number) => Promise<RolesListItem[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  RolesDto,
  RolesDto[],
  RoleCustomOperations
>({
  entityName: 'Role',
  endpoint: ROLE,

  customOperations: (auth) => ({
    getRolesPermissionData: async (): Promise<RolesListItem[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TLKP_ROLES + TLKP_ROLES_WITH_PERMISSIONS
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    addRolePermission: async (param: any): Promise<AxiosResponse> => {
      try {
        const res = await auth.makeAuthenticatedPost(
          TLKP_ROLES_PERMISSONS,
          param
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    updateRolePermissions: async (
      params: RolesUpdateDto
    ): Promise<AxiosResponse> => {
      try {
        const res = await auth.makeAuthenticatedPut(
          TLKP_ROLES_PERMISSONS + TLKP_ROLES_PERMISSONS_UPDATE,
          params
        );
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getRolepermissionsByRoleId: async (
      roleId: number
    ): Promise<RolesListItem[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          ROLE + GET_ROLE_PERMISSIONS_BY_ROLE_ID + `?roleId=${roleId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getRolePermissionsByUserId: async (
      userId: number
    ): Promise<RolesListItem[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          ROLE + GET_ROLE_PERMISSIONS_BY_USER_ID + `?userId=${userId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const RoleContext = Context;
export const useRoleManager = useManager;
export const useRole = useConsumer;
